export default __webpack_public_path__ + "static/media/I-2017.a84bbe38.pdf";